import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import ActivityIcon from '@mui/icons-material/Assignment';
import EqualizerIcon from '@mui/icons-material/Equalizer';
import WorkIcon from '@mui/icons-material/Work';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import ForumIcon from '@mui/icons-material/Forum';

import { RankingType } from '@ts-core/utils/Constants';
import { Feature } from '@ts-core/utils/features';

import { useCourse } from 'modules/courses/hooks';

export default function useQuickLinks({ courseId }) {
  const intl = useIntl();

  const { academyHasFeature } = useCourse({ courseId });

  const items = useMemo(() => {
    const result = [
      {
        title: intl.formatMessage({ id: 'quickLink.assignments' }),
        icon: WorkIcon,
        to: 'assignments',
      },
    ];

    if (academyHasFeature(Feature.Activities)) {
      result.push({
        title: intl.formatMessage({ id: 'quickLink.activities' }),
        icon: ActivityIcon,
        to: `activities`,
      });
    }

    if (academyHasFeature(Feature.Ranking)) {
      result.push({
        title: intl.formatMessage({ id: 'quickLink.rankings' }),
        icon: EqualizerIcon,
        to: `rankings/${RankingType.general}`,
      });
    }

    result.push(
      {
        title: intl.formatMessage({ id: 'quickLink.practiceSessions' }),
        icon: FitnessCenterIcon,
        to: 'practice',
      },
      {
        title: intl.formatMessage({ id: 'quickLink.courseStats' }),
        icon: TrendingUpIcon,
        to: 'stats',
      }
    );

    if (academyHasFeature(Feature.Forum)) {
      result.push({
        title: intl.formatMessage({
          id: 'quickLink.forum',
          defaultMessage: 'Foro',
        }),
        icon: ForumIcon,
        to: 'forum',
      });
    }
    return result;
  }, [academyHasFeature, intl]);

  return items;
}
